import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const AccordionItemWrapper = styled(Box)`
  min-height: auto;
  & > a {
    min-height: 32px;
    display: flex;
    align-items: center;
  }
`;

interface DropdownItemProps {
  active?: boolean;
}

export const DropdownItem = styled.button<DropdownItemProps>`
  background-color: transparent;
  border: none;
  text-align: left;
  max-width: 255px;
  padding: ${({ theme }) =>
    `${theme.spacings.spacing6} ${theme.spacings.spacing6} ${theme.spacings.spacing6} ${theme.spacings.xs}`};
  ${({ theme }) => theme.fonts.text14Medium};
  border-radius: ${({ theme }) => theme.rounds.button2Round};
  word-break: break-word;
  cursor: pointer;
  line-height: 20px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.accentContainer};
    span {
      color: ${({ theme }) => theme.colors.textAccent};
      ${({ active }) => (active ? 'font-weight: bold' : '')};
    }
  }
`;

export const DROPDOWN_PANEL_MIN_WIDTH = 340;
export const DROPDOWN_PANEL_MARGIN = 8;
/** Minimum horizontal space required to open the dropdown panel to a side */
export const DROPDOWN_PANEL_REQUIRED_SPACE = DROPDOWN_PANEL_MIN_WIDTH + DROPDOWN_PANEL_MARGIN * 2;

interface DropdownPanelProps {
  $openToLeft?: boolean;
}

export const DropdownPanel = styled(Box)<DropdownPanelProps>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ $openToLeft }) =>
    $openToLeft
      ? `right: 100%; margin-right: ${DROPDOWN_PANEL_MARGIN}px;`
      : `left: 100%; margin-left: ${DROPDOWN_PANEL_MARGIN}px;`}
  min-width: ${DROPDOWN_PANEL_MIN_WIDTH}px;
  max-height: 470px;
  background: ${({ theme }) => theme.colors.canvas};
  border-radius: ${({ theme }) => theme.rounds.container2Round};
  padding-top: ${({ theme }) => theme.spacings.spacing12};
  box-shadow: ${({ theme }) => theme.shadows.active['box-shadow']};
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
`;
